import React from "react";
import * as core from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CreatableSelect from "react-select/creatable";

const ClientSelectByAdmin = (props) => {
  const {
    touched,
    errors,
    values,
    handleBlur,
    handleChange,
    setFieldValue,
    setWorkerDemanderId,
    clients,
  } = props;
  const { t } = useTranslation();

  return (
    <core.Card>
      <core.CardHeader
        title={t("pages.workrequest.clientSelectByAdmin.stepname")}
      />
      <core.Divider />
      <core.CardContent>
        <core.Box height={200}>
          <core.Paper elevation={4}>
            <core.Grid container>
              <core.Grid item md={12} xs={12}>
                <CreatableSelect
                  fullWidth
                  isClearable
                  name="workerDemanderId"
                  onBlur={handleBlur}
                  value={{
                    value: values.workerDemanderId,
                    label: values.workerDemanderName,
                  }}
                  onChange={(newValue, actionMeta) => {
                    // console.log(newValue);
                    setWorkerDemanderId(newValue);
                    setFieldValue("workerDemanderId", Number(newValue.value));
                    setFieldValue("workerDemanderName", newValue.label);
                  }}
                  options={clients}
                />
              </core.Grid>
            </core.Grid>
          </core.Paper>
        </core.Box>
        <>
          {/* This state
        <pre>{JSON.stringify(values, null, 2)}</pre>
        <br />
        Master state
        <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
        </>
      </core.CardContent>
      <core.Divider />
    </core.Card>
  );
};

export default ClientSelectByAdmin;
